import React, { useState, useEffect } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { Box, Toolbar, AppBar, IconButton, useMediaQuery } from "@mui/material";
import { Navigate, Outlet } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";

import AppSideNav from "./AppSideNav";
import { APP_BAR_HEIGHT, DRAWER_WIDTH } from "../utils/constants";
import Avatar from "./components/Avatar"; // Assuming this is your user menu avatar
import AvatarProfile from "./components/Avatar";
import ActionIconButton from "./components/ActionIconButton";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";

// --- STYLED COMPONENTS FOR THE LAYOUT ---
const Main = styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  flexGrow: 1,

  // [theme.breakpoints.up("xs")]: {
  //   padding: theme.spacing(1),
  // },

  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),

  marginLeft: 0,
  // margin: 10,
  marginTop: `${APP_BAR_HEIGHT}px`,
  padding: theme.spacing(2),

  overflowY: "auto", // Enable vertical scrolling
  height: `calc(100vh - ${APP_BAR_HEIGHT}px)`,
  // height: `calc(100vh)`,

  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0, // Slides to its final position
  }),
}));

const StyledAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${DRAWER_WIDTH}px)`,
    marginLeft: `${DRAWER_WIDTH}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));
// --- END STYLED COMPONENTS ---

const AppLayout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [isNavOpen, setNavOpen] = useState(!isMobile);

  useEffect(() => {
    if (!isMobile) {
      setNavOpen(true); // On desktop, keep it open
    } else {
      setNavOpen(false); // On mobile, keep it closed
    }

    // setNavOpen(!isMobile);
  }, [isMobile]);

  // if (!isLoggedIn) {
  //   return <Navigate to="/login" />;
  // }

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <StyledAppBar open={!isMobile && isNavOpen} elevation={1}>
        <Toolbar
          sx={{ height: APP_BAR_HEIGHT, backgroundColor: "background.paper" }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => setNavOpen(true)}
            edge="start"
            sx={{
              mr: 2,
              display: isNavOpen && !isMobile ? "none" : "block",
            }}
          >
            <MenuIcon color="primary" />
          </IconButton>

          <Box
            sx={{
              display: "flex",
            }}
          >
            <img
              src={"/images/logo/dSacco.png"}
              alt="logo"
              style={{ width: "16%" }}
            />
          </Box>
          <Box sx={{ flexGrow: 1 }} />

          <AvatarProfile />
        </Toolbar>
      </StyledAppBar>

      <AppSideNav
        isOpen={isNavOpen}
        onClose={() => setNavOpen(false)}
        isMobile={isMobile}
      />

      <Main open={!isMobile && isNavOpen}>
        <Outlet />
      </Main>
    </Box>
  );
};

export default AppLayout;
